export default __webpack_public_path__ + "b77c18ac91304b7c3d5248cd1c7a47c0.svg";